import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig } from 'ep-bt-controls';

import { ActivatedRoute,  Router, NavigationExtras } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient, WebTrackUser, GetProductPurchasesRequest, CustomerProductPurchaseSearchParameters } from 'ep-bt-field-agent-proxy';

import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { GetCustomerNotepadItemsRequest, PagingParameters, SortParameters, SortParametersDirection, GetCustomerNotepadItemsRequestConsumer } from 'ep-bt-field-agent-proxy';
import { PanelBarItemModel } from '@progress/kendo-angular-layout';
import { variable } from '@angular/compiler/src/output/output_ast';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-products-purchased-details',
  templateUrl: './epbt-fa-customer-products-purchased-details.component.html',
  styleUrls: ['./epbt-fa-customer-products-purchased-details.component.scss']
})
export class EpbtFaCustomerProductsPurchasedDetailsComponent implements OnInit {


  products: any;
  @Input() customerId: number;
  productdetails: any;
  deliveryaddress: any;
  @ViewChild('dateTemplate', {static: false}) dateTemplate: TemplateRef<any>;
  currency: string;
  bisTrackSettings: any;

  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private router: Router, private fieldAgentService: EpbtFieldAgentService, private config: BistrackConfig) {
    this.productdetails = this.router.getCurrentNavigation().extras.state;
    this.route.queryParams.subscribe(params => {
      this.customerId = params['id'];
    });
    // console.log('productdetails',this.productdetails);
   }

  ngOnInit() {
    // this.bisTrackSettings = this.fieldAgentService.getBisTrackSetting();
    // this.currency= this.bisTrackSettings.baseCurrency.symbol;
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bisTrackSettings = bistrackSettings;
      this.currency = this.bisTrackSettings.baseCurrency.symbol;
    });
  }

  // address field mapping start

  getAddressData(addressObj: any) {
    let address = '';
    // (addressObj.addressId) ? address += addressObj.addressId : '';
    // (addressObj.addressCode) ? address += ', ' + addressObj.addressCode : '';
    (addressObj.address1) ? address += addressObj.address1 : '';
    (addressObj.address1) ? address += ', ' + addressObj.address2 : '';
    (addressObj.city) ? address += ', ' + addressObj.city : '';
    (addressObj.county) ? address += ', ' + addressObj.county : '';
    (addressObj.postCode) ? address += ', ' + addressObj.postCode : '';
    (addressObj.country) ? address += ', ' + addressObj.country : '';
    return address;
  }

  // address field mapping end

}
